import { render, staticRenderFns } from "./MoveQuestionModal.vue?vue&type=template&id=09767d89&"
import script from "./MoveQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./MoveQuestionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports